import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

// material-ui
import { Box, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { PlaylistAdd } from '@mui/icons-material';

// project import
import NavItem from './NavItem';
import { useOnboarding } from '../../../../../../contexts/OnboardingContext';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

const NavGroup = ({ item, handleDrawerToggle }) => {
    const menu = useSelector((state) => state.menu);
    const { drawerOpen } = menu;
    const { hasRoutes, setShowExampleWorkflowsModal } = useOnboarding();

    const handleExampleWorkflowsClick = () => {
        setShowExampleWorkflowsModal(true);
        if (handleDrawerToggle && drawerOpen) {
            handleDrawerToggle();
        }
    };

    // Check if we should show the example button (in Stations group, after Routes item, only when no routes exist)
    const showExampleButton = item.id === 'group-stations' && !hasRoutes;

    const navCollapse = item.children?.map((menuItem) => {
        const navItem = (() => {
            switch (menuItem.type) {
                case 'collapse':
                    return (
                        <Typography key={menuItem.id} variant="caption" color="error" sx={{ p: 2.5 }}>
                            collapse - only available in paid version
                        </Typography>
                    );
                case 'item':
                    return <NavItem key={menuItem.id} item={menuItem} level={1} handleDrawerToggle={handleDrawerToggle} />;
                default:
                    return (
                        <Typography key={menuItem.id} variant="h6" color="error" align="center">
                            Fix - Group Collapse or Items
                        </Typography>
                    );
            }
        })();

        // Insert Example Routes button right after Routes item
        if (menuItem.id === 'routes' && showExampleButton) {
            return (
                <React.Fragment key={menuItem.id}>
                    {navItem}
                    <ListItemButton
                        onClick={handleExampleWorkflowsClick}
                        sx={{
                            zIndex: 1201,
                            pl: drawerOpen ? '56px' : 1.5,
                            py: 1,
                            ...(drawerOpen && {
                                '&:hover': {
                                    bgcolor: 'primary.lighter'
                                }
                            })
                        }}
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: 28,
                                color: 'text.primary',
                                ...(!drawerOpen && {
                                    borderRadius: 1.5,
                                    width: 36,
                                    height: 36,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    '&:hover': {
                                        bgcolor: 'secondary.lighter'
                                    }
                                })
                            }}
                        >
                            <PlaylistAdd style={{ fontSize: drawerOpen ? '1rem' : '1.25rem' }} />
                        </ListItemIcon>
                        {drawerOpen && (
                            <ListItemText
                                primary={
                                    <Typography variant="h6" sx={{ color: 'text.primary' }}>
                                        Example Routes
                                    </Typography>
                                }
                            />
                        )}
                    </ListItemButton>
                </React.Fragment>
            );
        }

        return navItem;
    });

    return (
        <List
            subheader={
                item.title &&
                drawerOpen && (
                    <Box sx={{ pl: 3, mb: 1.5 }}>
                        <Typography variant="subtitle2" color="textSecondary">
                            {item.title}
                        </Typography>
                        {/* only available in paid version */}
                    </Box>
                )
            }
            sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}
        >
            {navCollapse}
        </List>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object,
    handleDrawerToggle: PropTypes.func
};

export default NavGroup;
